export default {
  emptyUserObj: {
    id: "",
    firstName: "",
    lastName: "",
    licenseType: "",
    name: "",
    onBoarding: false,
    otpVerified: false,
    phoneNumber: "",
    profileCompleted: false,
    status: "",
    profileImage: "",
    studies: [],
    userRole: "",
    username: "",
    workNumber: ""
  },
  user: {
    id: "",
    firstName: "",
    lastName: "",
    licenseType: "",
    name: "",
    onBoarding: false,
    otpVerified: false,
    phoneNumber: "",
    profileCompleted: false,
    status: "",
    profileImage: "",
    studies: [],
    userRole: "",
    username: "",
    workNumber: ""
  },
  participant: {
    active: false,
    baseUrl: null,
    consentStatus: false,
    country: "",
    countryId: "",
    email: "",
    languageId: "",
    languageName: "",
    mlFLag: false,
    optInSMS: false,
    participantMeta: {},
    address: "",
    city: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    state: "",
    zipcode: "",
    pid: "",
    registrationDate: null,
    source: "WEB",
    startDate: null,
    status: "",
    studyId: "",
    studyVersionId: "",
    threadParticipantId: "",
    userDefinedParticipantId: ""
  },
  token: "",
  refreshToken: "",
  clientId: "",
  clientName: "",
  awsToken: "",
  showLoader: false,
  participantAWSToken: "",
  studyStartStatus: {
    isConfirmed: false,
    isPiConfirmed: false,
    isReschedule: false
  },
  participantRegistration: {
    activationToken: "",
    deviceId: "",
    deviceType: "",
    email: "",
    verificationMethod: "email",
    mobileCountryCode: "",
    mobile: "",
    verificationOptInSMS: false,
    participantLocalOffset: "",
    participantLocalTime: "",
    confirmPassword: "",
    participantMeta: {
      address: "",
      dob: "",
      city: "",
      country: "",
      countryCode: null,
      regCustomField1: "",
      regCustomField2: "",
      regCustomField3: "",
      email: "",
      firstName: "",
      gender: "",
      howDidYouHear: "",
      language: "",
      lastName: "",
      optInSMS: false,
      parentOrCgFirstName: "",
      parentOrCgLastName: "",
      password: "",
      phoneNumber: "",
      smsCountryIsoName: "",
      state: "",
      zipcode: null
    },
    password: "",
    pid: null,
    registrationProcess: "",
    studyId: null,
    studyVersionId: ""
  },
  sessionExpired: false
};
